// extracted by mini-css-extract-plugin
module.exports = {"right_img":"rightImageLeftNews-m__right_img__3tZVp","news_item":"rightImageLeftNews-m__news_item__6gwmI"};